import { usePageTitle } from '../../hooks/usePageTitle';
import { Card, CardContent } from '../../components/ui/Card';
import { OverviewTable } from '../../components/carrier-engagement/OverviewTable';

const CarrierEngagementDashboardPage = () => {
  usePageTitle('Carrier Engagement Dashboard');

  return (
    <div className="-m-6 h-[calc(100vh-104px)] flex flex-col bg-background font-sans antialiased">
      <div className="w-full px-3 py-4 flex flex-col flex-1 min-h-0">
        <Card className="flex flex-col flex-1 min-h-0">
          <CardContent
            className="p-0 flex flex-col flex-1 min-h-0"
            data-testid="overview-table-wrapper"
          >
            <OverviewTable />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export { CarrierEngagementDashboardPage };
